import { MessagingService } from 'src/app/services/messaging.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResponseTimeService {
  private responses: any[] = [];
  private longestResponseTime = 0;

  constructor(private messagingService: MessagingService) {}

  registerResponse(url: string, responseTime: number): void {
    this.responses.push({
      url,
      responseTime,
    });
    if (this.longestResponseTime < responseTime) {
      this.longestResponseTime = responseTime;
      this.messagingService.longestResponseTimeChanged.emit(responseTime);
    }
  }

  getLongestResponseTime(): number {
    return this.longestResponseTime;
  }

  resetLongestResponseTime(): void {
    this.longestResponseTime = 0;
    this.messagingService.longestResponseTimeChanged.emit(
      this.longestResponseTime
    );
  }
}
